module.exports = __webpack_public_path__ + "static/media/David_Fesliyan_Quiet_Morning.a1f230a3.mp3";